export default {
    button: {
        next: 'Seuraava',
        previous: 'Edellinen',
        create_listing: 'Lähetä tarjouspyyntö',
        processing: 'Käsitellään...',
    },    
    confirm: {
        create_listing: 'Ostotarjouksen luonti on kesken. Haluatko varmasti poistua sivulta?'
    },
    label: {    
        location_address: 'Katuosoite',
        location_city: 'Paikkakunta',
        location_zip: 'Postinumero',
        odometer: 'KM',
        
        register_plate: 'Rekisteritunnus',
        make: 'Merkki',
        commercial_name: 'Malli',
        year: 'Vuosimalli',
        model: 'Mallitarkennus',
        fuel_type: 'Käyttövoima',
        max_net_power: 'Moottoriteho kW',
        cylinder_volume: 'Moottoritilavuus',
        vin: 'Alustanumero',
        transmission: 'Vaihteisto',
        drive_type: 'Vetotapa',
        
        damage_type: {
            engine: 'Moottorivika',
            transmission: 'Vaihteistovika',
            crash: 'Pelti- tai kolarivaurio',
            other: 'Joku muu',
        },

        first_name: 'Etunimi',
        last_name: 'Sukunimi',
        mobile: 'Puhelinnumero',
        email: 'Sähköposti',
        address: 'Katuosoite',
        zip: 'Postinumero',
        city: 'Paikkakunta',
        company: 'Yritys (jos yritysasiakas)',
    },
    title: {
        car_information: 'Autosi tiedot',
        car_damage_information: 'Autosi vauriotiedot',
        car_location: 'Autosi sijainti',
        car_kilometers: 'Autosi ajokilometrit',
        server_errors: 'Palvelin palautti virheitä!',
    }
}